
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bantuan/lainnya",
      function () {
        return require("private-next-pages/bantuan/lainnya.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bantuan/lainnya"])
      });
    }
  